// "Voor elke situatie" — Swiper carousel controller.
// Uses common.View so it survives canvas-editor saves (re-inits per
// instance when the block's DOM is replaced).

common.View.create('canvas.blocks.site.scenarios.Block', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {
        const $slider = this.element.find('.site-scenarios-slider');
        if (!$slider.length || typeof Swiper === 'undefined') return;

        const el = $slider[0];

        // Defensive: drop any prior Swiper bound to this element before
        // re-binding (handles editor save re-render race conditions).
        if (el.swiper && typeof el.swiper.destroy === 'function') {
            el.swiper.destroy(true, true);
        }

        const isEditor = $('body').hasClass('canvas-editor');

        new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: false,
            watchOverflow: true,
            allowTouchMove: !isEditor,
            grabCursor: !isEditor,
            navigation: {
                prevEl: this.element.find('.site-scenarios-nav--prev')[0],
                nextEl: this.element.find('.site-scenarios-nav--next')[0],
            },
            breakpoints: {
                640:  { slidesPerView: 1.4, spaceBetween: 24 },
                768:  { slidesPerView: 2,   spaceBetween: 28 },
                1024: { slidesPerView: 3,   spaceBetween: 36 },
            },
            a11y: {
                prevSlideMessage: 'Vorige slide',
                nextSlideMessage: 'Volgende slide',
            },
            keyboard: { enabled: !isEditor },
        });
    },
});
